import React from 'react';
import ProfileMenu from "./ProfileMenu";
import {IconButton, Typography} from "@material-tailwind/react";
import PersianNumberFormat from "../../helper/PersianNumberFormat";
import {BsList} from "react-icons/bs";
import {NotificationsMenu} from "./NotificationsMenu";
import {RolesMenu} from "./RolesMenu";


const Header = ({className, userInfo, isOpen, setIsOpen, onClick}) => {
  const {name, family, phone} = userInfo;


  return <header
    className={`${className} flex w-full justify-between px-4 shadow-lg z-10`}
    style={{
      transition: "box-shadow .25s ease-in, background-color .25s ease-in !important",
      // boxShadow: "inset 0 0 1px 1px hsla(0,0%,100%,.9), 0 20px 27px 0 rgba(0,0,0,.05)!important",
      backgroundColor: "rgba(255, 255, 255, 0.8)!important",
      backdropFilter: "saturate(200%) blur(30px) !important"
    }}
  >
    <div className="flex flex-row">
      {!isOpen ?
        <IconButton variant="text" onClick={() => {
          setIsOpen(true)
        }} color="blue-gray" className="text-4xl font-bold">
          <BsList/>
        </IconButton>
        : null
      }
      <div>

        <RolesMenu onClick={onClick}/>

      </div>

      <Typography variant="h5" color="blue-gray" textGradient className="pr-2">
        <Typography>
          سلام {name}
        </Typography>
        <Typography variant="small" color="blue-gray">
          {PersianNumberFormat(phone)}
        </Typography>
      </Typography>
    </div>
    <div className="flex flex-row gap-x-4">
      <NotificationsMenu onClick={onClick}/>
      <ProfileMenu className="pl-2" onClick={onClick}/>
    </div>
  </header>;
};

export default Header;
